export default [
    {
        path: '/404',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/NotFound.vue`
            )
    },
    {
        path: '/403',
        meta: {
            public: true,
        },
        name: 'AccessDenied',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Deny.vue`
            )
    },
    {
        path: '/500',
        meta: {
            public: true,
        },
        name: 'ServerError',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Error.vue`
            )
    },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'Login',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Login.vue`
            )
    },
    {
        path: '/',
        meta: { public: true },
        name: 'Root',
        redirect: {
            name: 'Dashboard'
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        props: { obj: 'dashboardCorban' },
        meta: {
            title: 'Dashboard',
            filterComponent: () => import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy-once" */
                `@/pages/DashboardFilter.vue`
                )
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Dashboard.vue`
            )
    },
    {
        path: '/pendingAppUsers',
        name: 'PendingAppUsers',
        meta: {
            title: 'Validar Clientes (App)',
        },
        component: () => import(
            '@/pages/PendingAppUsers'
        )
    },
    {
        path: '/pendingAffiliates',
        name: 'PendingAffiliates',
        meta: {
            title: 'Validar Afiliados',
        },
        component: () => import(
            '@/pages/PendingAffiliates'
        )
    },
    {
        path: '/prospection',
        name: 'Prospection',
        meta: {
            title: 'Simulador',
            layout: 'EmptyLayout'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Prospection.vue`
            )
    },
    {
        path: '/clients',
        name: 'Clients',
        meta: {
            title: 'Clientes',
            filterComponent: () => import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy-once" */
                `@/pages/ClientFilter.vue`
                )
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Clients.vue`
            )
    },
    {
        path: '/client/:id',
        name: 'Client',
        meta: {
            title: 'Cliente'
        },
        props: { obj: 'client' },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/ClientForm.vue`
            )
    },
    {
        path: '/partners',
        name: 'Partners',
        meta: {
            title: 'Parceiros'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Partners.vue`
            )
    },
    {
        path: '/branches',
        name: 'Branches',
        meta: {
            title: 'Filiais/Agentes'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Branches.vue`
        )
    },
    {
        path: '/campaigns',
        name: 'Campaigns',
        props: true,
        meta: {
            title: 'Campanhas'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Campaigns.vue`
            )
    },
    {
        path: '/campaignDataImport',
        name: 'CampaignDataImport',
        meta: {
            title: 'Importar Planilha'
        },
        props: {
            newStateTitle: 'Importar Planilha',
            editStateTitle: 'Importar Planilha'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/CampaignDataImport.vue`
            )
    },
    {
        path: '/campaignDataFilter',
        name: 'CampaignDataFilter',
        meta: {
            title: 'Filtrar para Campanha'
        },
        props: {
            obj: 'campaign/dataRequest',
            newStateTitle: 'Filtrar para Campanha',
            editStateTitle: 'Filtrar para Campanha'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/CampaignDataFilter.vue`
            )
    },
    {
        path: '/workflow',
        name: 'Workflow',
        meta: {
            title: 'Propostas',
            filterProps: { kind: 'EST' },
            filterComponent: () => import(
                /* webpackChunkName: "routes" */
                /* webpackMode: "lazy-once" */
                `@/pages/ContractFilter.vue`
                )
        },
        props: { kind: 'EST' },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Contracts.vue`
            )
    },
    {
        path: '/contracts',
        name: 'Contracts',
        meta: {
            title: 'Contratos',
            filterProps: { kind: 'CTT' },
            filterComponent: () => import(
                `@/pages/ContractFilter.vue`
            )
        },
        props: { kind: 'CTT' },
        component: () => import(
            `@/pages/Contracts.vue`
        )
    },
    {
        path: '/paidContracts',
        name: 'Paid Contracts',
        meta: {
            title: 'Contratos Pagos',
            filterProps: { kind: 'CMS' },
            filterComponent: () => import(
                `@/pages/ContractFilter.vue`
            )
        },
        props: { kind: 'CMS' },
        component: () => import(
            `@/pages/Contracts.vue`
        )
    },
    {
        path: '/production',
        name: 'Production',
        meta: {
            title: 'Produção Por Status',
            filterComponent: () => import(
                `@/pages/ProductionFilter.vue`
            )
        },
        component: () => import(
            `@/pages/Production.vue`
        )
    },
    {
        path: '/campaignLeads',
        name: 'CampaignLeads',
        meta: {
            title: 'Produção Por Campanha',
            filterComponent: () => import(
                `@/pages/CampaignLeadsFilter.vue`
            )
        },
        component: () => import(
            `@/pages/CampaignLeads.vue`
        )
    },
    {
        path: '/workflow',
        name: 'Propostas',
        meta: {
            title: 'Propostas',
            filterProps: {},
            filterComponent: () => import(
                `@/pages/ContractFilter.vue`
            )
        },
        props: {},
        component: () => import(
            `@/pages/ContractForm.vue`
        )
    },
    {
        path: '/commissions',
        name: 'Commissions',
        meta: {
            title: 'Comissões',
            filterProps: { kind: 'CMS' },
            filterComponent: () => import(
                `@/pages/ContractFilter.vue`
            )
        },
        props: {
            kind: 'CMS',
            key: +new Date()
        },
        component: () => import(
            `@/pages/Contracts.vue`
        )
    },
    {
        path: '/bankChart',
        name: 'BanKChart',
        meta: {
            title: 'Tabela de Coeficientes'
        },
        component: () => import(
            `@/pages/BankCharts.vue`
        )
    },
    {
        path: '/todayFactors',
        name: 'TodayFactors',
        meta: {
            title: 'Coeficientes de Hoje'
        },
        component: () => import(
            `@/pages/TodayFactors.vue`
        )
    },
    {
        path: '/receivePaymt',
        name: 'ReceivePaymt',
        meta: {
            title: 'Receber Pagamento'
        },
        props: {
            obj: 'exchangeJournal',
            newStateTitle: 'Receber Pagamento',
            editStateTitle: 'Alterar Recebimento'
        },
        component: () => import(
            `@/pages/ReceivePaymt.vue`
        )
    },
    {
        path: '/extraFee',
        name: 'ExtraFee',
        meta: {
            title: 'Lançar Taxa Extra'
        },
        props: {
            obj: 'exchangeJournal',
            newStateTitle: 'Lançar Taxa Extra',
            editStateTitle: 'Alterar Taxa Extra'
        },
        component: () => import(
            `@/pages/ExtraFee.vue`
        )
    },
    {
        path: '/closeCashier/:id',
        name: 'CloseCashier',
        meta: {
            title: 'Fechar Caixa',
            filterComponent: () => import(
                `@/pages/CloseCashierFilter.vue`
            )
        },
        props: {
            obj: 'closeReport',
            newStateTitle: 'Fechar Caixa',
            editStateTitle: 'Caixa Fechado'
        },
        component: () => import(
            `@/pages/CloseCashier.vue`
        )
    },
    {
        path: '/employees',
        name: 'Employees',
        meta: {
            title: 'Usuários'
        },
        component: () => import(
            `@/pages/Employees.vue`
        )
    },
    {
        path: '/links',
        name: 'Links',
        meta: {
            title: 'Links'
        },
        component: () => import(
            `@/pages/Links.vue`
        )
    },
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            title: 'Afiliados',
            filterComponent: () => import(
                `@/pages/AffiliateFilter.vue`
            )
        },
        component: () => import(
            `@/pages/Affiliates.vue`
        )
    },
    {
        path: '/changepin',
        name: 'ChangePin',
        meta: {
            title: 'Alterar Senha'
        },
        props: {
            newStateTitle: 'Alterar Senha',
            editStateTitle: 'Alterar Senha'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/change-pin.vue`
            )
    },
    {
        path: '/sms',
        name: 'SendSMS',
        meta: {
            title: 'Enviar SMS'
        },
        props: {
            newStateTitle: 'Enviar SMS',
            editStateTitle: 'Enviar SMS'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/SendSMS.vue`
            )
    },
    {
        path: '/company',
        name: 'Company',
        meta: {
            title: 'Minha Empresa'
        },
        props: {
            obj: 'company',
            newStateTitle: 'Minha Empresa',
            editStateTitle: 'Minha Empresa'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Company.vue`
            )
    },
    {
        path: '/autoDialer',
        name: 'AutoDialer',
        meta: {
            title: 'Configurações Discador'
        },
        props: { obj: 'autoDialer' },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/AutoDialer.vue`
            )
    },
    {
        path: '/requests',
        name: 'Requests',
        meta: {
            title: 'Solicitações'
        },
        component: () => import(
            `@/pages/Requests.vue`
            )
    },
    {
        path: '/addCash',
        name: 'AddCash',
        meta: {
            title: 'Depositar no Caixa'
        },
        props: {
            obj: 'exchangeJournal',
            newStateTitle: 'Depositar no Caixa',
            editStateTitle: 'Depositar no Caixa'
        },
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/AddCash.vue`
            )
    },
    {
        path: '*',
        name: 'any',
        meta: {
            public: true,
        },
        redirect: {
            path: '/404'
        }
    }
];
 


// WEBPACK FOOTER //
// ./src/router/paths.js